import { ApolloError, useMutation } from "@apollo/client";

import type {
  UpdateDeviceInput,
  UpdateDeviceMutation,
  UpdateDeviceMutationVariables,
} from "../../../API";
import { UPDATE_DEVICE } from "../../../common/operations/mutations";
import { errorNotification } from "../../../common/variables/notification";

export const useUpdateDevice = () => {
  const [putDevice, { data, loading }] = useMutation<
    UpdateDeviceMutation,
    UpdateDeviceMutationVariables
  >(UPDATE_DEVICE);

  const updateDevice = async (input: UpdateDeviceInput) => {
    return await putDevice({
      variables: {
        input,
      },
      onError: (error: ApolloError): void => {
        console.error(error);

        errorNotification(error.message);
      },
    });
  };

  return { updateDevice, data, loading };
};
